import { createSlice } from "@reduxjs/toolkit"
import { addProduct, allProductNoPagination, getActiveProduct, getAllProduct, getAllProductCount, getInActiveProduct, getProduct, toggleProductStatus, updateProduct } from "../actions/product";

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    allProductList: [],
    productListNoPagination: [],
    singleProduct: null,
    allProductCount: 0,
    inActiveProduct: 0,
    activeProduct: 0,
    total: 0,
}

export const productSlice = createSlice({
    name: "product",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {
        //=====================
        // Add new product
        //======================
        builder.addCase(addProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(addProduct.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(addProduct.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all product with pagination
        //=================================
        builder.addCase(getAllProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allProductList = action.payload.data?.data;
            state.total = action.payload.data?.total
        });
        builder.addCase(getAllProduct.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all product without pagination
        //=================================
        builder.addCase(allProductNoPagination.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(allProductNoPagination.fulfilled, (state, action) => {
            state.isLoading = false;
            state.productListNoPagination = action.payload.data?.product;
        });
        builder.addCase(allProductNoPagination.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get single product
        //===========================
        builder.addCase(getProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleProduct = action.payload.data?.product;
        });
        builder.addCase(getProduct.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get all product count
        //===========================
        builder.addCase(getAllProductCount.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllProductCount.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allProductCount = action.payload.data?.product;
        });
        builder.addCase(getAllProductCount.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get inActive product
        //===========================
        builder.addCase(getInActiveProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getInActiveProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.inActiveProduct = action.payload.data?.inActiveProduct;
        });
        builder.addCase(getInActiveProduct.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get active brand
        //===========================
        builder.addCase(getActiveProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getActiveProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.activeProduct = action.payload.data?.activeProduct;
        });
        builder.addCase(getActiveProduct.rejected, (state) => {
            state.isError = true;
        });

        //============================
        // toggle product status
        //============================
        builder.addCase(toggleProductStatus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(toggleProductStatus.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(toggleProductStatus.rejected, (state) => {
            state.isError = true;
        });

        //==============================
        //update product
        //=============================
        builder.addCase(updateProduct.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateProduct.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(updateProduct.rejected, (state) => {
            state.isError = true;
        });
    }
})

export default productSlice.reducer;